module.exports = __webpack_public_path__ + "media/img/slider_bcg@2x-a2de1c33.png";